// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__3TNSp","small":"Badge_small__156Qq","tiny":"Badge_tiny__3Xwp3","gray":"Badge_gray__18-LO"};